import { render, staticRenderFns, recyclableRender, components } from "./u-image.vue?vue&type=template&id=042b391e&scoped=true&"
var renderjs
import script from "./u-image.vue?vue&type=script&lang=js&"
export * from "./u-image.vue?vue&type=script&lang=js&"
import style0 from "./u-image.vue?vue&type=style&index=0&id=042b391e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042b391e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-image/u-image.vue"
export default component.exports